import { render, staticRenderFns } from "./BaseCollapse.vue?vue&type=template&id=775a98e7&scoped=true"
import script from "./BaseCollapse.vue?vue&type=script&lang=js"
export * from "./BaseCollapse.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapse.vue?vue&type=style&index=0&id=775a98e7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a98e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('775a98e7')) {
      api.createRecord('775a98e7', component.options)
    } else {
      api.reload('775a98e7', component.options)
    }
    module.hot.accept("./BaseCollapse.vue?vue&type=template&id=775a98e7&scoped=true", function () {
      api.rerender('775a98e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wizard/BaseCollapse.vue"
export default component.exports